import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";
export default function CounterSalesItemCard({ item }) {
  return (
    <Card
      sx={{
        width: "96%",
        mt: "12px",
        cursor: "pointer",
        backgroundColor: "#E8E8FF",
        "& .MuiCardContent-root": { p: "0rem" },
        borderRadius: "14px",
        padding: "10px ",
        paddingLeft: { xs: "10px", sm: "30px" },
        boxShadow: "none",
      }}
    >
      <CardContent sx={{ padding: "0rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={0} sm={1}></Grid>

          <Grid item xs={4} sm={3}>
            <Typography
              color="primary"
              sx={{
                fontSize: { xs: "10px", sm: "13px", md: "15px" },
                // overflow: "Hidden",
                // display: "-webkit-box",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                fontWeight: 500,
                fontFamily: "'Montserrat', sans-serif",
                color: "black",
                px: { xs: "0px", sm: "22px" },
                textAlign: "center",

                borderRadius: "10px",
              }}
            >
              {item?.billDate
                ? convertDateToCustomFormat(item?.billDate?.split("T")[0])
                : convertDateToCustomFormat(item?.createdDate?.split("T")[0])}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography
              color="primary"
              sx={{
                textAlign: "center",
                fontSize: { xs: "10px", sm: "13px", md: "15px" },
                // overflow: "Hidden",
                // display: "-webkit-box",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                fontWeight: 500,
                fontFamily: "'Montserrat', sans-serif",
                color: "black",
                px: { sm: "10px", xs: "0px" },
                borderRadius: "10px",
              }}
            >
              {item?.name}
            </Typography>
          </Grid>

          <Grid
            item
            xs={3}
            sx={{
              pl: { sm: 2, md: 5, xs: 2, lg: 10 },
              pr: { xs: 0, md: 7, sm: 5, lg: 10 },
            }}
          >
            {/* <Box p={1}> */}
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              <CurrencyRupeeIcon
                sx={{
                  fontSize: { xs: "10px", sm: "13px", md: "15px" },
                  color: "#000",
                }}
              />
              <Typography
                fontWeight={500}
                align="right"
                sx={{
                  flex: 1,
                  textAlign: "right",
                  fontSize: { xs: "10px", sm: "13px", md: "15px" },
                }}
              >
                {item.amount?.toFixed(2)}
              </Typography>
            </Box>
            {/* </Box> */}
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
